import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { merge } from 'lodash';

const HighChart = ({ containerProps, options }) => {
  const commonOptions = {
    credits: {
      enabled: false
    }
  };
  const config = merge(commonOptions, options);

  const containerPropsOptions = {
    ...containerProps,
    style: {
      width: '100%',
      height: '100%',
      ...containerProps?.style
    }
  };

  return (
    <HighchartsReact
      containerProps={containerPropsOptions}
      highcharts={Highcharts}
      options={config}
    />
  );
};

export default HighChart;
